// ISO 639-1 based controlled language list (code + localized labels).
export const LANGUAGES = [
  { code: "fr", fr: "Français", en: "French" },
  { code: "en", fr: "Anglais", en: "English" },
  { code: "ar", fr: "Arabe", en: "Arabic" },
  { code: "es", fr: "Espagnol", en: "Spanish" },
  { code: "pt", fr: "Portugais", en: "Portuguese" },
  { code: "de", fr: "Allemand", en: "German" },
  { code: "it", fr: "Italien", en: "Italian" },
  { code: "ru", fr: "Russe", en: "Russian" },
  { code: "zh", fr: "Chinois", en: "Chinese" },
  { code: "ja", fr: "Japonais", en: "Japanese" },
  { code: "ko", fr: "Coréen", en: "Korean" },
  { code: "hi", fr: "Hindi", en: "Hindi" },
  { code: "bn", fr: "Bengali", en: "Bengali" },
  { code: "pa", fr: "Pendjabi", en: "Punjabi" },
  { code: "ur", fr: "Ourdou", en: "Urdu" },
  { code: "fa", fr: "Persan", en: "Persian" },
  { code: "tr", fr: "Turc", en: "Turkish" },
  { code: "vi", fr: "Vietnamien", en: "Vietnamese" },
  { code: "th", fr: "Thaï", en: "Thai" },
  { code: "id", fr: "Indonésien", en: "Indonesian" },
  { code: "ms", fr: "Malais", en: "Malay" },
  { code: "tl", fr: "Tagalog", en: "Tagalog" },
  { code: "sw", fr: "Swahili", en: "Swahili" },
  { code: "am", fr: "Amharique", en: "Amharic" },
  { code: "ha", fr: "Haoussa", en: "Hausa" },
  { code: "yo", fr: "Yoruba", en: "Yoruba" },
  { code: "ig", fr: "Igbo", en: "Igbo" },
  { code: "wo", fr: "Wolof", en: "Wolof" },
  { code: "ln", fr: "Lingala", en: "Lingala" },
  { code: "so", fr: "Somali", en: "Somali" },
  { code: "ta", fr: "Tamoul", en: "Tamil" },
  { code: "te", fr: "Télougou", en: "Telugu" },
  { code: "ml", fr: "Malayalam", en: "Malayalam" },
  { code: "mr", fr: "Marathe", en: "Marathi" },
  { code: "gu", fr: "Goujarati", en: "Gujarati" },
  { code: "pl", fr: "Polonais", en: "Polish" },
  { code: "uk", fr: "Ukrainien", en: "Ukrainian" },
  { code: "ro", fr: "Roumain", en: "Romanian" },
  { code: "nl", fr: "Néerlandais", en: "Dutch" },
  { code: "el", fr: "Grec", en: "Greek" },
  { code: "he", fr: "Hébreu", en: "Hebrew" },
  { code: "sv", fr: "Suédois", en: "Swedish" },
  { code: "cs", fr: "Tchèque", en: "Czech" },
  { code: "hu", fr: "Hongrois", en: "Hungarian" },
  { code: "ka", fr: "Géorgien", en: "Georgian" },
  { code: "hy", fr: "Arménien", en: "Armenian" },
  { code: "az", fr: "Azéri", en: "Azerbaijani" },
  { code: "kk", fr: "Kazakh", en: "Kazakh" },
  { code: "ps", fr: "Pachto", en: "Pashto" },
  { code: "ne", fr: "Népalais", en: "Nepali" },
  { code: "si", fr: "Cingalais", en: "Sinhala" },
  { code: "km", fr: "Khmer", en: "Khmer" },
  { code: "my", fr: "Birman", en: "Burmese" },
];

export const LANG_MAP = Object.fromEntries(LANGUAGES.map((l) => [l.code, l]));
export const langLabel = (code, lang) => (LANG_MAP[code] ? LANG_MAP[code][lang] : code);

// Interest suggestions (free display but limited/curated set for tags)
export const INTEREST_SUGGESTIONS = {
  fr: ["Sport", "Musique", "Cinéma", "Lecture", "Cuisine", "Voyage", "Jeux vidéo", "Photographie", "Art", "Danse", "Randonnée", "Bénévolat", "Technologie", "Mode", "Football", "Théâtre"],
  en: ["Sport", "Music", "Cinema", "Reading", "Cooking", "Travel", "Video games", "Photography", "Art", "Dance", "Hiking", "Volunteering", "Technology", "Fashion", "Football", "Theatre"],
};

export const MAX_TAGS = 8;
export const MAX_TAG_LEN = 30;
